/** @jsx jsx */
import { jsx } from '@emotion/react';

import { useParams } from 'js/lib/useRouter';

import { PageGridContainer } from '@coursera/cds-core';

import { redirectClientOrServer } from 'bundles/common/utils/urlUtils';
import GrowthDiscoveryEpicClient from 'bundles/epic/clients/GrowthDiscovery';
import SkillSetCardsModule from 'bundles/page-config-common/components/enterprise/SkillSetCardsModule';
import SkillSetCardsNotConfigurable from 'bundles/page-config-common/components/enterprise/SkillSetCardsNotConfigurable';
import HomeSection from 'bundles/page-config-common/components/shared/HomeSection';
import { usePageContext } from 'bundles/page-config-common/contexts/PageContext';
import { useAcademicDisciplineName } from 'bundles/page-config-common/contexts/enterprise/AcademicDisciplineContext';
import { useEnterpriseSkillsets } from 'bundles/page-config-common/contexts/enterprise/EnterpriseSkillSetsContext';
import { useEnterpriseProductFeatures } from 'bundles/unified-common/contexts/EnterpriseProductFeaturesContext';
import { useProgram } from 'bundles/unified-common/contexts/EnterpriseProgramContext';

const EnterpriseSkillSetCardsModuleRenderer = () => {
  const { programSlug } = useParams();
  const program = useProgram();
  const pageContext = usePageContext();
  const features = useEnterpriseProductFeatures();
  const { academicDisciplineName } = useAcademicDisciplineName();
  const { hasError, skillsetsLoading, skillsets } = useEnterpriseSkillsets();

  const skillSetLength = program?.metadata?.linkedTargetSkillProfileIds?.length;

  const enableEnterpriseHomeRefresh = GrowthDiscoveryEpicClient.preview('enableEnterpriseHomeRefresh');

  if (pageContext?.isEnterprise && program && features && skillSetLength) {
    return (
      <HomeSection className="PageConfig_SkillSetCardsComponent">
        {enableEnterpriseHomeRefresh ? (
          <PageGridContainer data-testid="enterprise-skill-sets-module">
            <SkillSetCardsModule
              programSlug={programSlug}
              skillSetLength={skillSetLength}
              showSkillSets={() => redirectClientOrServer(`/programs/${programSlug}/skillsets`)}
              skillsets={skillsets}
              skillsetsLoading={skillsetsLoading}
              hasError={hasError}
            />
          </PageGridContainer>
        ) : (
          <SkillSetCardsNotConfigurable
            showSkillSetRoleFilter={features?.showSkillSetRoleFilter}
            programSlug={programSlug}
            programId={program.id}
            showSkillSets={() => redirectClientOrServer(`/programs/${programSlug}/skillsets`)}
            skillSetLength={skillSetLength}
            enableC4CAcademicDisciplines={features?.enableAcademicDisciplines}
            academicDisciplineName={academicDisciplineName}
          />
        )}
      </HomeSection>
    );
  } else {
    return null;
  }
};

export default EnterpriseSkillSetCardsModuleRenderer;
